module.exports = __webpack_public_path__ + "static/img/R200_c.b9e2aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/R200_c.png
// module id = Pw+7
// module chunks = 0